import moment from 'moment'
import Config from '../../Config'
import {
  CLAIMS_LOADING,
  CLAIMS_SUCCESS,
  CLAIMS_FAILED,
  CLAIMSFILTER_LOADING,
  CLAIMSFILTER_SUCCESS,
  CLAIMSFILTER_FAILED,
  CLAIMS_PAGE_CHANGE,
  CLAIMS_PAGE_SIZE,
  CLAIMS_STORE_FILTERS
} from '../actions/claimsActions'

const getDefaultStartPeriod = () => moment().subtract(Config.defaultPreviousYearsToShowClaims, 'year').startOf('day').format()

const getDefaultEndPeriod = () => moment().endOf('day').format()

const applyDefaultFilters = (filterObj = {}) => {
  const {
    members,
    benefit,
    status,
    onlyReceipts,
    startPeriod,
    endPeriod,
    ...filters
  } = filterObj

  return {
    ...filters,
    members: members || 0,
    benefit: benefit || 0,
    status: status || 0,
    onlyReceipts: !!onlyReceipts,
    startPeriod: startPeriod || getDefaultStartPeriod(),
    endPeriod: endPeriod || getDefaultEndPeriod()
  }
}

const getDefaultState = () => {
  const defaultFilterObj = applyDefaultFilters({})
  return { defaultFilterObj, filterObj: defaultFilterObj }
}

const Claims = (state = getDefaultState(), action) => {
  switch (action.type) {
    case CLAIMS_LOADING:
      return Object.assign({}, state, {
        claims: null,
        isLoading: true,
        error: null
      })

    // when loading the page, begin on page one with a default setting of ten claims
    // per page
    case CLAIMS_SUCCESS:
      return Object.assign({}, state, {
        claims: action.response && action.response.claimsList,
        claimsFiltered: false,
        pageNum: state.pageNum || 1,
        pageSize: state.pageSize || Config.defaultPageSize,
        totalPages: action.response.totalPages,
        totalClaims: action.response.totalClaims,
        error: null,
        isLoading: false
      })
    case CLAIMS_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        claims: null,
        isLoading: false
      })
    case CLAIMSFILTER_LOADING:
      return Object.assign({}, state, {
        claims: null,
        isLoading: true,
        filters: null,
        error: null,
        totalClaims: 0
      })
    case CLAIMSFILTER_SUCCESS:
      const pageSize = state.pageSize || Config.defaultPageSize
      return Object.assign({}, state, {
        pageNum: state.pageNum || 1,
        pageSize: pageSize,
        totalPages: Math.ceil(action.response.length / pageSize),
        totalClaims: action.response.totalClaims,
        filters: action.response,
        error: null,
        isLoading: state.isLoading
      })
    case CLAIMSFILTER_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        filters: null,
        isLoading: state.isLoading
      })
    case CLAIMS_PAGE_CHANGE:
      return Object.assign({}, state, {
        pageNum: action.pageNum,
        pageSize: state.pageSize || Config.defaultPageSize
      })
    case CLAIMS_PAGE_SIZE:
      return Object.assign({}, state, {
        pageSize: action.pageSize,
        pageNum: 1
      })
    case CLAIMS_STORE_FILTERS:
      return Object.assign({}, state, {
        filterObj: applyDefaultFilters(action.filterObj)
      })
    default:
      return state
  }
}
export default Claims



// WEBPACK FOOTER //
// ./src/redux/reducers/claimsReducer.js